/*
 * Author: Roger
 * File Created: Wednesday, 24-08-14 12:24 pm
 * Last Modified: Wednesday, 24-08-14 12:28 pm, by Roger
 */

const Facebook = () => {
  return <svg fill="none" viewBox="0 0 73 72" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="Facebook" data-sentry-source-file="Facebook.tsx">
      <g clipPath="url(#clip0_5280_2604)" data-sentry-element="g" data-sentry-source-file="Facebook.tsx">
        <path d="M36.4771 1.86568C17.6264 1.86568 2.34277 17.1493 2.34277 36C2.34277 54.8507 17.6264 70.1343 36.4771 70.1343C55.3278 70.1343 70.6114 54.8507 70.6114 36C70.6114 17.1493 55.3278 1.86568 36.4771 1.86568Z" stroke="white" strokeMiterlimit="10" strokeWidth="3.73134" data-sentry-element="path" data-sentry-source-file="Facebook.tsx" />
        <path d="M32.5448 51.5896V33.9702H29.6045V29.8657H32.5448V28.9328C32.5448 26.1194 33.306 23.3134 35.1791 21.5299C36.7836 20.0149 38.9702 19.4328 40.8433 19.4328C42.3134 19.4328 43.4776 19.6567 44.3657 19.9702L43.9627 24.209C43.3806 23.9851 42.6269 23.806 41.6418 23.806C38.9179 23.806 37.9851 26.0821 37.9851 28.7537V29.8657H42.7612V33.9702H38.0299V51.5896H32.5448Z" fill="white" data-sentry-element="path" data-sentry-source-file="Facebook.tsx" />
      </g>
      <defs data-sentry-element="defs" data-sentry-source-file="Facebook.tsx">
        <clipPath id="clip0_5280_2604" data-sentry-element="clipPath" data-sentry-source-file="Facebook.tsx">
          <rect fill="white" height="72" transform="translate(0.477539)" width="72" data-sentry-element="rect" data-sentry-source-file="Facebook.tsx" />
        </clipPath>
      </defs>
    </svg>;
};
export default Facebook;